<!-- LoadingTela.svelte -->
<script>
  export let isLoading = false;
</script>

<style>
  .loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(254, 249, 249, 0.80); /* Cinza com 30% de opacidade */
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 2000; /* Para garantir que fique sobreposto a outros elementos */
  }

  .loading-icon-wrapper {
    position: relative;
    width: 200px;
    height: 200px; /* Ajuste o tamanho conforme necessário */
  }

  .loading-icon {
    position: absolute;
    width: 100%;
    height: 100%;
  }

  .background-icon {
    opacity: 0.3; /* 30% de opacidade */
   
  }

  .foreground-icon {
   
    clip-path: polygon(50% 50%, 50% 0%, 100% 0%, 100% 100%, 0% 100%, 0% 0%, 50% 0%); /* Inicialmente invisível */
    animation: slice 2s infinite linear; /* Animação de fatiamento */
  }

  @keyframes slice {
    0% {
      clip-path: polygon(50% 50%, 50% 0%, 50% 0%);
    }
    12.5% {
      clip-path: polygon(50% 50%, 50% 0%, 75% 0%);
    }
    25% {
      clip-path: polygon(50% 50%, 50% 0%, 100% 0%);
    }
    37.5% {
      clip-path: polygon(50% 50%, 50% 0%, 100% 0%, 100% 25%);
    }
    50% {
      clip-path: polygon(50% 50%, 50% 0%, 100% 0%, 100% 50%);
    }
    62.5% {
      clip-path: polygon(50% 50%, 50% 0%, 100% 0%, 100% 75%);
    }
    75% {
      clip-path: polygon(50% 50%, 50% 0%, 100% 0%, 100% 100%);
    }
    87.5% {
      clip-path: polygon(50% 50%, 50% 0%, 100% 0%, 100% 100%, 75% 100%);
    }
    100% {
      clip-path: polygon(50% 50%, 50% 0%, 100% 0%, 100% 100%, 0% 100%, 0% 75%);
    }
  }
</style>

{#if isLoading} 
  <div class="loading-overlay">
    <div class="loading-icon-wrapper">
      <img src="img/logo2.webp" alt="Loading" class="loading-icon background-icon" onerror="this.onerror=null;this.src='img/logo2.png'" />
      <img src="img/logo2.webp" alt="Loading" class="loading-icon foreground-icon" onerror="this.onerror=null;this.src='img/logo2.png'" />
    </div>
  </div>
{/if}
